import React from 'react';

import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import styled from 'styled-components';

const Container = styled.div`
    z-index: 2;
    display: flex;
    min-width: 100%;
    min-height: 20em;
    position: relative;
    align-items: center;
    max-width: 21.0625em;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: space-around;
    color: ${({ theme }) => theme.colors.white};
    padding: ${({ theme }) => theme.space.mouse};
    border-radius: ${({ theme }) => theme.radii[2]};
    font-size: ${({ theme }) => theme.fontSizes.mouse};
    background-color: ${({ theme }) => theme.colors.backgroundVariant};

    h2 {
        font-size: 2.5em;
    }
    
    h3 {
        text-align: center;
        font-size: 1.4375em;
        font-weight: ${({ theme }) => theme.fontWeights.light};
    }
    
    p {
        font-weight: ${({ theme }) => theme.fontWeights.bold};;
    }
`;

const AuthMaintenance = () => (
    <Container>
        <h2><FormattedMessage id="authFunctional.maintenance.title" /></h2>

        <h3><FormattedHTMLMessage id="authFunctional.maintenance.message" /></h3>

        <p><FormattedMessage id="authFunctional.maintenance.backSoon" /></p>
    </Container>
);

export default AuthMaintenance;
